import { useEffect, useState } from "react" 
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    FetchData,
    Helpers,

    defaultData,
    
    //------------- Forms
    Forms,
    
    globalStates

})=>{

    const navigate = useNavigate();

    const {convertToFloat} = Helpers


    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const {setModalOpeningMode} = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {
        
        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        onResetForm()
        closeModal()
    }

    const handleClickCloseForm = () => {
        const { FormRequestGlobal } = Forms
        const { onResetForm} = FormRequestGlobal
        onResetForm()
        // navigate si funcionó
        navigate('/administrador-vehiculos-gestiones')
    }


    const handleChangeContract = async (event) => {

        //HOOKS
        const { FormRequestGlobal } = Forms
        const {setFormState, formState} = FormRequestGlobal
        
        const {setShowFormContract, showFormContract} = globalStates
        
        const {fetchInfoContract:{executeFetchInfoContract}} =FetchData
        
        const { name, value } = event.target
        
        setFormState(prevState => ({
            ...prevState,
            [ name ]: value
        }))

        await executeFetchInfoContract()

        setShowFormContract(true)
    }

    const onSubmitFormRequests = async (e) => {
        e.preventDefault()

        const { FormRequestGlobal } = Forms
        const {formState} = FormRequestGlobal

        const {getCurrentDate} = Helpers

        const _body = {
            idgestion: formState.idgestion,
            aprobacion_check: formState.aprobacion_check,
            aprobacion_fecha:getCurrentDate(),
            aprobacion_usuario: user.username,
        }

        if(formState.aprobacion_check!=='Pendiente Aprobacion'){
            await marvarApi.put(`/vehicle/admin-managements/aprobacion-check`, _body)
            .then(({data}) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    handleClickCloseForm()
                }
            })
        }
        handleClickCloseForm()
    }

    const onSendLogs = async (e) => {

        
        const { FormRequestGlobal } = Forms
        const {formState, setFormState} = FormRequestGlobal

        const { fetchInfoObservations:{executeFetchAllObservations} } = FetchData


        const {getCurrentDate} = Helpers
        
        // const { fetchAllTypeManagements:{typeManagements} } = FetchData
        
        await marvarApi.post(`/vehicle/common/log-management/${formState.idgestion}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Administrador"
        })
        .then(({data}) => {
            alertMessage(data)
            if (data.title === 'OK') {
                setFormState((prevState) => ({
                    ...prevState,
                    aprobacion_observaciones: ''
                }))
                executeFetchAllObservations()
            }
        })
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {clean_deposito_monto, deposito_tipo_cambio} = formState
        
        const { name, value } = event.target
    
        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;
    
    
        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto*tipo_cambio),
                deposito_dolares : numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto*tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        }else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto),
                deposito_dolares : numberFormatter.format(clean_deposito_monto/tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto/tipo_cambio)
            }))
        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState, onInputChangeForNumber} = FormDeposit
        const {deposito_tipo_cambio} = formState
        
        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales : numberFormatter.format(clean_value*tipo_cambio),
                deposito_dolares : numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value*tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales : numberFormatter.format(clean_value),
                deposito_dolares : numberFormatter.format(clean_value/tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value/tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const {FormDeposit} = Forms
        const {setFormState, formState} = FormDeposit
        const {clean_deposito_monto} = formState
        
        const { name, value } = event.target

        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto*tipo_cambio),
                deposito_dolares : numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto*tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        }else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value,
                deposito_quetzales : numberFormatter.format(clean_deposito_monto),
                deposito_dolares : (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto/tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto/tipo_cambio)
            }))
        }else {
            setFormState(prevState => ({
                ...prevState,
                [ name ]: value
            }))
        }
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()
    
        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState
    
        const {fetchAllDeposits} = FetchData
        const {executeFetchAllDeposits} = fetchAllDeposits

        const {getCurrentDate} = Helpers
    
        
        if(formState.movimiento_tipo==='EFECTIVO'){
    
            const _data = {
                idcredito: formStateGlobal.idcredito,
                idgestiontipo: formStateGlobal.idgestiontipo,
                deposito_usuario: user.username,
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones : `RETIRO GPS - ${formState.deposito_observaciones}`,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post( `/vehicle/mgmt-managements/create-deposit-cash`, _data )
                .then(({ data }) => {
    
                        alertMessage(data)
    
                        if (data.title === 'OK') {
                            onResetForm()
                            executeFetchAllDeposits()
                            closeModal()
                        }
                    
                    })
                    .catch(error => {
                            console.log('API ERROR: ', error)
                    })
    
        console.log(_data);

        }
    
    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()
      
        const { FormRequestGlobal:{formState, setFormState} } = Forms
        const {getCurrentDate} = Helpers

        if(formState.acceptedFiles.length<=0){
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return 
        }

        const _data = new FormData();

        _data.append('idgestiontipo', formState.idgestiontipo);
        _data.append('idcredito', formState.idcredito);
        _data.append('department', '');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if(formState.idcredito>0){
            
            await marvarApi.post( `/vehicle/mgmt-managements/create-document`, _data )
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            check_carta: true,
                            acceptedFiles : [],
                            fileRejections : []
                        }))
                    }
                        alertMessage(data)
                    })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
                    
        }
    }

    const handleClickFetchInfoDeposit = async (idmovimiento) => {
        
        const { FormDeposit: {onResetForm}} = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        console.log(idmovimiento);
        
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idmovimiento: idmovimiento})
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }



  

    return Object.freeze({
        handleClickCloseForm,
        handleChangeContract,
        onSubmitFormRequests,
        onSendLogs,
        handleClickShowModal,
        handleClickCloseModal,
        handleClickFetchInfoDeposit,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        onSubmitFormDeposits,
        onSubmitFormFiles
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message} = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}